/* The sticky action delegates to the real product button, including its add-ons. */
(() => {
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 767px)');
  const controllers = new Map();

  function init(scope = document) {
    scope.querySelectorAll('[data-frame-mobile-sticky-actions]').forEach((bar) => {
      if (controllers.has(bar)) return;
      const info = bar.closest('.gp-frame-product__information');
      const button = bar.querySelector('[data-frame-sticky-cart]');
      if (!info || !button) return;

      let mainButton;
      let mainVisible = false;
      let frame;
      const priceUi = info.querySelector('[data-price-ui]');
      const title = bar.querySelector('[data-sticky-product-title]');
      const price = bar.querySelector('[data-sticky-product-price]');
      const compare = bar.querySelector('[data-sticky-compare-price]');
      const headingUi = info.querySelector('h1');
      const purchaseButtons = info.querySelector('[data-frame-primary-cta]')?.parentElement;
      const buttonChanges = new MutationObserver(schedule);

      function publishHeight() {
        const height = bar.hidden ? 0 : Math.ceil(bar.getBoundingClientRect().height);
        const value = `${height}px`;
        if (root.style.getPropertyValue('--gp-sticky-cart-height') !== value) {
          root.style.setProperty('--gp-sticky-cart-height', value);
        }
        if (root.classList.contains('gp-pdp-sticky-visible') !== (height > 0)) {
          root.classList.toggle('gp-pdp-sticky-visible', height > 0);
        }
      }

      function sync() {
        frame = null;
        if (!mobile.matches) {
          if (!bar.hidden) bar.hidden = true;
          publishHeight();
          return;
        }
        const nextButton = info.querySelector('[data-frame-primary-cta]');
        if (nextButton !== mainButton) {
          if (mainButton) intersection.unobserve(mainButton);
          buttonChanges.disconnect();
          mainButton = nextButton;
          if (mainButton) {
            intersection.observe(mainButton);
            buttonChanges.observe(mainButton, {
              attributes: true,
              attributeFilter: ['disabled', 'hidden', 'aria-busy', 'data-gp-busy', 'data-frame-notify-cta', 'class'],
            });
          }
        }
        const rect = mainButton?.getBoundingClientRect();
        mainVisible = !!rect && rect.height > 0 && rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        const available = !!rect && rect.height > 0 && rect.width > 0 && !mainButton.hidden && !mainButton.hasAttribute('data-frame-notify-cta') && !mainButton.classList.contains('gp-frame-primary-cta--sold-out');
        const visible = mobile.matches && available && !mainVisible && !root.classList.contains('gp-frame-builder-open');
        if (!visible && !bar.hidden && bar.contains(document.activeElement)) {
          mainButton?.focus({ preventScroll: true });
        }
        if (bar.hidden === visible) bar.hidden = !visible;
        const busy = mainButton?.dataset.gpBusy === 'true' || mainButton?.getAttribute('aria-busy') === 'true';
        const disabled = !available || mainButton.disabled || busy;
        if (button.disabled !== !!disabled) button.disabled = !!disabled;
        if (button.getAttribute('aria-busy') !== String(!!busy)) button.setAttribute('aria-busy', String(!!busy));

        const heading = headingUi?.textContent.trim();
        if (heading && title.textContent !== heading) title.textContent = heading;
        const current = priceUi?.querySelector('.price .money, .price--sale .money, [data-price] .money');
        const previous = priceUi?.querySelector('.compare-at-price .money, [data-compare-at-price] .money');
        if (current && price.textContent !== current.textContent.trim()) price.textContent = current.textContent.trim();
        const previousText = previous?.textContent.trim() || '';
        const previousVisible = previousText && previous.getClientRects().length > 0 && getComputedStyle(previous).visibility !== 'hidden';
        const hideCompare = !previousText || !previousVisible;
        if (compare.hidden !== !!hideCompare) compare.hidden = !!hideCompare;
        if (compare.textContent !== previousText) compare.textContent = previousText;
        publishHeight();
      }

      function schedule() {
        if (!frame) frame = requestAnimationFrame(sync);
      }

      const intersection = new IntersectionObserver(schedule, { threshold: [0, 1] });
      const changes = new MutationObserver(schedule);
      // Review and payment widgets mutate frequently. Only price, title and real
      // purchase-control changes affect this bar; ignore the rest of the panel.
      if (priceUi) changes.observe(priceUi, {
        childList: true, subtree: true, characterData: true, attributes: true,
        attributeFilter: ['hidden', 'class', 'style'],
      });
      if (headingUi) changes.observe(headingUi, {childList: true, subtree: true, characterData: true});
      if (purchaseButtons) changes.observe(purchaseButtons, {childList: true});
      let builderOpen = root.classList.contains('gp-frame-builder-open');
      const builderState = new MutationObserver(() => {
        const next = root.classList.contains('gp-frame-builder-open');
        if (next !== builderOpen) {
          builderOpen = next;
          schedule();
        }
      });
      builderState.observe(root, { attributes: true, attributeFilter: ['class'] });
      const size = new ResizeObserver(schedule);
      size.observe(bar);
      const viewport = window.visualViewport;
      window.addEventListener('resize', schedule, { passive: true });
      viewport?.addEventListener('resize', schedule, { passive: true });
      // IO is the normal scroll path; resize and mutations also recheck visibility.
      mobile.addEventListener('change', schedule);
      button.addEventListener('click', () => {
        if (button.disabled || !mainButton || mainButton.disabled) return;
        mainButton.click();
        schedule();
      });
      controllers.set(bar, () => {
        intersection.disconnect();
        changes.disconnect();
        buttonChanges.disconnect();
        builderState.disconnect();
        size.disconnect();
        window.removeEventListener('resize', schedule);
        viewport?.removeEventListener('resize', schedule);
        mobile.removeEventListener('change', schedule);
        if (frame) cancelAnimationFrame(frame);
        bar.hidden = true;
        publishHeight();
      });
      sync();
    });
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((destroy, bar) => {
      if (event.target.contains(bar)) {
        destroy();
        controllers.delete(bar);
      }
    });
  });
})();
